import React from "react";

const defaultEntryComponent = (props) => {
    const {
        mention,
        theme,
        isFocused, // eslint-disable-line no-unused-vars
        searchValue, // eslint-disable-line no-unused-vars
        ...parentProps
    } = props;

    return (
        <div {...parentProps}>
            <span className={theme.mentionSuggestionsEntryText}>{mention}</span>
        </div>
    );
};

export default defaultEntryComponent;
